import useMediaQuery from '@mui/material/useMediaQuery'
import { Theme } from '@mui/material/styles'

export const useShowOnDesktop = (): boolean =>
  useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
